import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { ProcessVersionInstanceSelectDialog } from "../Ui/Dialogs/ProcessVersionInstanceSelectDialog";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessInstanceItemStartEntityProcessPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessInstanceItemStartEntityProcessProperties = {
    [name in keyof EntityCommandProcessInstanceItemStartEntityProcessPropertyValues]: Property<EntityCommandProcessInstanceItemStartEntityProcessPropertyValues[name]>
};

export interface IEntityCommandProcessInstanceItemStartEntityProcess extends IEntityCommand, EntityCommandProcessInstanceItemStartEntityProcessProperties
{
}

export class EntityCommandProcessInstanceItemStartEntityProcess extends EntityCommand implements IEntityCommandProcessInstanceItemStartEntityProcess
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessInstanceItemStartEntityProcess";
    public static override className = "EntityCommandProcessInstanceItemStartEntityProcess";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessInstanceItemStartEntityProcessPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Start Entity Process",
                entityName: "ProcessInstanceItem",
                key: "START_ENTITY_PROCESS",
                permission: PermissionEvaluator.permissionLevels.execute,
                type: EntityCommandTypeEnum.entitySet,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessInstanceItemStartEntityProcessPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        await super._executeAsync(entityCommandInformation, value);

        const
            processVersionInstanceSelectDialog = ProcessVersionInstanceSelectDialog.instance,
            entityName = entityCommandInformation.parentEntityName.get(),
            recordId = entityCommandInformation.parentEntityId.get();

        if (!entityName)
            return;

        if (!recordId)
            return;

        const
            result = await processVersionInstanceSelectDialog.openAsync(entityName);

        if (result.dialogResult !== DialogResultEnum.ok)
            return;

        await
            ServiceManager.getRequired(WebApiClientService)
                .createApiMethodRequest(
                    "DataService",
                    "CallDataService",
                    {
                        id: "b185975f-0e14-4944-b706-6353f0d67dc4",
                        operation: "StartEntityProcess",
                        data: ObjectHelper.toJson({
                            processVersionId: result.promiseData.processVersionId,
                            entityName,
                            recordId,
                            synchronousContinuation: true
                        })
                    }
                )
                .executeAsync();
    }

    // #endregion

    // #endregion
}

